
<form id="permanent_planning_storecheck" [formGroup]="this.permanentPlanningStoreCheckForm" (ngSubmit)="this.save()">

    <div class="title_card">{{'EDIT_STORECHECK' | translate}}</div>   

    @if(this.storeCheck){
        @if(this.storeCheck.hasCoachingSession){
            <marv-message type="warning">{{'MSG_STORECHECK_COACH_SESSION' | translate}}</marv-message>
        }

        <div id="permanent_planning_storecheck_form">
            <marv-input-date 
                label="{{ 'DAY' | translate }}" 
                formName="day"            
                [fixedLabel]="true"      
                [withSpeechToText]="true" 
                />  

            <marv-input-time 
                label="{{ 'START_HOUR' | translate }}" 
                icon="time-outline" 
                formName="startHour" 
                [fixedLabel]="true" 
                [disabled]="this.storeCheck.hasCoachingSession"            
                />

            <marv-input-time 
                label="{{ 'DURATION' | translate }}" 
                icon="hourglass-outline" 
                formName="duration" 
                [fixedLabel]="true"     
                [disabled]="this.storeCheck.hasCoachingSession"          
                />

            @if(this.storeObjectives.length > 0){

                <marv-section-title label="{{'ACTIONS' | translate}}" icon="rocket-outline"/>

                @for(objective of this.storeObjectives; track $index){
                    <marv-checkbox 
                        [label]="objective.name" 
                        [formName]="'objective_'+objective.id"                         
                        [disabled]="objective.mandatory"
                        labelPlacement="end"
                        /> 
                }

            }

        </div>
    }

    <ion-grid id="footer_permanent_planning_storecheck">
        <ion-row class="ion-justify-content-around">
            <ion-col size="auto">
                <marv-button type="submit" label="{{ 'VALIDATE' | translate }}" icon="checkmark-outline" color="primary" [isFetching]="this.isFetchingSave"/>
            </ion-col>
            <ion-col size="auto">
                <marv-button type="button" label="{{ 'CANCEL' | translate }}" icon="close-outline" color="secondary" (click)="this.cancel()" />
            </ion-col>
        </ion-row>
    </ion-grid>

</form>
